<div class="fade show" id="loading" *ngIf="mostrarLock">
    <i class="spinner-grow spinner-grow-sm"></i>
    <span class="m-1">Cargando...</span>
</div>
<router-outlet></router-outlet>